import React, { Fragment } from "react";
import { Button } from "@duxton-web/ui";
import { MODAL_TYPE_FEATURE_FLAG } from "../../constants";
import { FeatureFlagManager } from "../../feature-flag-manager";
import { FlagOutlined } from "@duxton-web/icons";

const SidebarFeatureFlagManager = (props) => {
  const {
    handleOpenModal,
    handleCloseModal,
    collapsed,
    isModalOpen,
    modalType,
  } = props;
  const isModalVisible = isModalOpen && modalType === MODAL_TYPE_FEATURE_FLAG;

  const handleFeatureFlagBtnClick = (e) => {
    handleOpenModal(MODAL_TYPE_FEATURE_FLAG);
    e.target.blur();
  };

  const onClick = (e) => {
    if (collapsed) handleOpenModal(MODAL_TYPE_FEATURE_FLAG);
    else handleFeatureFlagBtnClick(e);
  };

  return (
    <Fragment>
      {/* set danger as not production sidebar */}
      <Button
        danger
        shape={collapsed ? "circle" : undefined}
        icon={<FlagOutlined style={collapsed ? { fontSize: 20 } : undefined} />}
        onClick={onClick}
        style={{ marginBottom: 16 }}
      >
        {collapsed ? "" : "Feature Flags"}
      </Button>
      <FeatureFlagManager
        visible={isModalVisible}
        onCancel={() => handleCloseModal(MODAL_TYPE_FEATURE_FLAG)}
      />
    </Fragment>
  );
};

export default SidebarFeatureFlagManager;
